/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_firstload = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if(pollConnection === 1) { poll_connection.onready(); }
		
		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();

		/*
		Lightbox
		*/
		$('.js-lightboxgallery a').simpleLightbox({
			history: false,
			overlayOpacity:0.9
		});

		/*
		Visitor recording
		*/
		specific_visitor_recording.onready();

		/*
		CookieBot
		*/
		setTimeout(function() {
			$('iframe[role="presentation"]').css({
				'display':'none'
			});
		}, 500);
		
		/*
		Lightbox
		*/
		var _lightgox_gallery1 = $('.js-lightboxgallery a').simpleLightbox({
			history: false,
			overlayOpacity:0.9
		});
		var _lightgox_gallery2 = $('.js-lightboxgallery-cabinus a').simpleLightbox({
			history: false,
			overlayOpacity:0.9
		});
		var _lightgox_gallery3 = $('.js-lightboxgallery-cabinur a').simpleLightbox({
			history: false,
			overlayOpacity:0.9
		});
		
		/*
		Lightbox: Cabinu houses galleries
		*/
		$(document).on('click', '.js-lightboxgallery-click', function (e) {
			_lightgox_gallery1.open();
			//$('.js-lightboxgallery a').eq(0).trigger('click');
		});
		$(document).on('click', '.js-lightboxgallery-cabinus-click', function(e) {
			_lightgox_gallery2.open();
		});
		$(document).on('click', '.js-lightboxgallery-cabinur-click', function(e) {
			_lightgox_gallery3.open();
		});

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_firstload); 